import { css } from '@/styled-system/css';

export const fileNameStyles = css.raw({
  truncate: true,
  marginLeft: 'tighter',
  paddingRight: 'default',
  maxWidth: '100%',
  lg: {
    maxWidth: '300px',
  },
});

export const cardStyles = css.raw({
  marginTop: 'tighter',
  display: 'flex',
  alignItems: 'center',
  height: '48px',
  backgroundColor: 'gray.100',
  maxWidth: 'fit-content',
});

export const imageThumbnailStyles = css.raw({
  borderRadius: '4px',
  overflow: 'hidden',
  width: '32px',
  minWidth: '32px',
  height: '24px',
});
